import { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/logos/logo.png";
import poplavskyGroup from "../../assets/logos/poplavsky-group.png";

import "./NavBar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("inicio");

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const navItems = [
    { id: "inicio", label: "Inicio", path: "/" },
    { id: "nosotros", label: "Nosotros", path: "/nosotros" },
    { id: "servicios", label: "Servicios", path: "/servicios" },
    { id: "novedades", label: "Novedades", path: "/novedades" },
  ];  

  return (
    <nav className="navbar">
      <div className="container">
        <div className="logo">
          <NavLink to="/" >
            <img src={logo} alt="Logo-TG" />
          </NavLink>
        </div>
        <ul className="nav-links">
          {navItems.map((item) => (
            <li key={item.id}>
              <NavLink
                to={item.path}
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={() => setActive(item.id)}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
        {/* Logo extra pegado al borde derecho */}
        <button className="menu-btn" onClick={toggleMenu}>
            {menuOpen ? "\u274C" : "\u2630"}
        </button>
      </div>
      <div className="extra-logo">
        <img src={poplavskyGroup} alt="Logo Extra" />
      </div>
      {menuOpen && (
        <ul className="mobile-menu">
          {navItems.map((item) => (
            <li key={item.id}>
              <NavLink
                to={item.path}
                className={active === item.id ? "active" : ""}
                onClick={() => {
                  setActive(item.id);
                  setMenuOpen(false);
                }}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}